import { render, staticRenderFns } from "./TextFieldWithSubmitButton.vue?vue&type=template&id=2dfd9377&scoped=true"
import script from "./TextFieldWithSubmitButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextFieldWithSubmitButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextFieldWithSubmitButton.vue?vue&type=style&index=0&id=2dfd9377&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd9377",
  null
  
)

export default component.exports